import 'bootstrap/dist/css/bootstrap.css';
import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate } from 'react-router-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import config from './config.json';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

const RootComponent = () => {
  const [authenticated, setAuthenticated] = useState(false);
  const [checkingAuthentication, setCheckingAuthentication] = useState(true);

  useEffect(() => {
    const checkAuthentication = async () => {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const tokenFromURL = urlSearchParams.get('token');
      const encodedUserData = urlSearchParams.get('U');
      const userData = encodedUserData || localStorage.getItem('UserData');
      const token = tokenFromURL || localStorage.getItem('token');

      if (!token) {
        // If the token is not present, redirect to the login page
        console.log('Token not found');
        const currentPath = window.location.href;
        localStorage.setItem('returnUrl', window.location.pathname);
        window.location.href = `${config.identityUrl}/Identity/Account/Login?returnUrl=${encodeURIComponent(currentPath)}`;
        return;
      }

      try {
        // Remove the token from the URL
        window.history.replaceState({}, document.title, window.location.pathname);
        // Decode the token without verifying signature
        const tokenPayload = JSON.parse(atob(token.split('.')[1]));

        // Check token expiration
        const currentTimestamp = Math.floor(Date.now() / 1000);

        if (tokenPayload.exp && tokenPayload.exp < currentTimestamp) {
          // Token has expired, redirect to the login page
          console.log('Token expired');
          const currentPath = window.location.href;
          localStorage.setItem('returnUrl', window.location.pathname);
          window.location.href = `${config.identityUrl}/Identity/Account/Login?returnUrl=${encodeURIComponent(currentPath)}`;
          return;
        }

        // Decode the user data
        const decodedUserData = JSON.parse(atob(userData));

        // Extract roles and set them in localStorage
        const roles = decodedUserData.Roles;
        localStorage.setItem('token', token);
        localStorage.setItem('UserData', userData);
        localStorage.setItem('Roles', JSON.stringify(roles));
        setAuthenticated(true);

        const returnUrl = localStorage.getItem('returnUrl');
        if (returnUrl) {
          window.location.href = returnUrl;
          localStorage.removeItem('returnUrl');
        }

      } catch (error) {
        console.error('Error decoding token:', error);
        // Handle the error as needed
      }
      finally {
        setCheckingAuthentication(false);
      }
    };

    checkAuthentication();
  }, []);

  if (checkingAuthentication) {
    return <div>Loading...</div>;
  }

  // If not authenticated, redirect to the login page
  if (!authenticated) {
    const currentPath = window.location.href;
    localStorage.setItem('returnUrl', window.location.pathname);
    return <Navigate to={`${config.identityUrl}/Identity/Account/Login?returnUrl=${encodeURIComponent(currentPath)}`} />;
  }

  return (
      <BrowserRouter basename="/">
          <React.StrictMode>
              <App />
          </React.StrictMode>
      </BrowserRouter>
  );
};

root.render(<RootComponent />);
serviceWorkerRegistration.unregister();
reportWebVitals();